import {IDataSourceItem} from '@/features/data-sources'
import './style.css'

export interface ITabTitleProps<T extends IDataSourceItem> {
  data: T
  onClick: (data: T) => void
}

export function TabTitle<T extends IDataSourceItem>(props: ITabTitleProps<T>) {
  const {data, onClick} = props

  function handleOnClick() {
    if (!onClick) return
    if (!data) return
    onClick(data)
  }

  return (
    <div
      className='tab-title'
      onClick={handleOnClick}
    >
      <div className='content'>
        {data.title || data._id}
        {data.year ? ` (${data.year})` : null}
      </div>
      <div className='info'>
        <div>{data.position ? `#${data.position}` : '-'}</div>
        {data.sortScore ?
          <div>({data.sortScore.toFixed(3)})</div>
        : undefined}
      </div>
    </div>
  )
}
